module.exports = __webpack_public_path__ + "img/icon_search.ee68c8ce.svg";